export const charge = {
  charge: {
    shape:
      '<path fill="#000" fill-opacity=".51" d="M11.575 16.225V12.85h-1.7l2.55-5.075v3.375h1.7l-2.55 5.075ZM7.625 22c-.467 0-.854-.154-1.162-.462-.309-.309-.463-.696-.463-1.163V3.625c0-.467.154-.854.463-1.163C6.771 2.154 7.158 2 7.625 2h8.75c.467 0 .854.154 1.163.462.308.309.462.696.462 1.163v16.75c0 .467-.154.854-.462 1.163-.309.308-.696.462-1.163.462h-8.75ZM7 19.5v.875c0 .167.063.312.188.437s.27.188.437.188h8.75a.597.597 0 0 0 .437-.188.597.597 0 0 0 .188-.437V19.5H7Zm0-1h10v-13H7v13Zm0-14h10v-.875a.597.597 0 0 0-.188-.437.597.597 0 0 0-.437-.188h-8.75a.597.597 0 0 0-.437.188.597.597 0 0 0-.188.437V4.5Zm0 15V21v-1.5Z"/>',
    viewBox: [0, 0, 24, 24],
  },
};
